const THEWOOIMPERIAL = (() => {

    // SELECTOR
    const SELECTOR = {
        kv: '.imperial-kv',
        kvText: '.imperial-kv__content',
        kvObject: '.imperial-kv__object',

        phoenix: '.imperial-phoenix__sticky-box',
        phoenixObject: '.imperial-phoenix__object img',

        fadeEffect: '.is-hidden-default, .is-hidden-up'
    }

    // KvFrame
    const kvFrame = (() => {
        const saveStyle = () => [`${SELECTOR.kvObject}, ${SELECTOR.kvText}`];

        const setup = () => gsap.timeline({
            scrollTrigger: {
                trigger: SELECTOR.kv,
                start: 'top top',
                end: '+=1000',
                scrub: true,
                ease: 'none',
                pin: true,
                invalidateOnRefresh: true
                // markers: true,
            }
        })
        .to(
            SELECTOR.kvObject, 
            { opacity: 0.3 }
        )
        .to(
            SELECTOR.kvText, 
            { opacity: 1 },
            0.2
        );

        return {saveStyle, setup};
    })();

    // phoneix
    const phonexFrame = (() => {
        const saveStyle = () => [`${SELECTOR.phoenixObject}`];

        const setup = () => gsap.timeline({
            scrollTrigger: {
                trigger: SELECTOR.phoenix,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
                ease: 'none',
                invalidateOnRefresh: true
                // markers: true,
            }
        })
        .to(SELECTOR.phoenixObject, 
            {
                scale: 1.5,
            }
        )

        return {saveStyle, setup};
    })();

    // fadeEffect
    const fadeEffect = (() => {
        const setup = () => ScrollTrigger.batch(SELECTOR.fadeEffect, {
            start: 'top bottom',
            // markers: true,
            invalidateOnRefresh: true,
            onEnter: (batch) => {
                // ScrollTrigger.refresh();
                batch.forEach(item => {
                    item.classList.add('is-visible');
                });
            },
            onLeaveBack: (batch) => {
                // ScrollTrigger.refresh();
                batch.forEach(item => {
                    item.classList.remove('is-visible');
                });
            }
        });

        return { setup };
    })();

    // saveStyle
    const saveStyles = () => {
        const allStyles = [
            ...kvFrame.saveStyle(),
            ...phonexFrame.saveStyle()
        ];
        ScrollTrigger.saveStyles(allStyles);
    }
    
    const init = () => {

        gsap.registerPlugin(ScrollTrigger);

        saveStyles();

        ScrollTrigger.matchMedia({

            
            // all
            all: () => {

                // kvFrame.setup();
                // kvFrame.setup();

                // phoenix
                // phonexFrame.setup();

                // fadeEffect
                fadeEffect.setup();

                // palallax
                new setParallax('.imperial-kv', '.imperial-kv__object', '0%', '20%', 'top top');
                new setParallax('.imperial-video', '.imperial-video__object');

            },

            // mobile
            '(max-width: 750px)': () => {

            },

            // pc
            '(min-width: 751px)': () => {
            }


        });

    }

    return {
        init: () => {
            init();
        }
    }

})();

document.addEventListener("DOMContentLoaded", function () {
    THEWOOIMPERIAL.init();
});